// extracted by mini-css-extract-plugin
export var arbiterBadgeContainer = "_1s-0";
export var circle = "_1s-8";
export var colorSwatch = "_1s-5";
export var compactSwatch = "_1s-7";
export var fillWidth = "_1s-4";
export var iconButton = "_1s-2";
export var iconWrapper = "_1s-3";
export var shadow = "_1s-6";
export var xs = "_1s-1";